/* eslint-disable no-redeclare */
type Dictionary<T extends string, U extends string = string> = { [K in T]: U };

export function translate<T extends string, U extends string>(
  term: T,
  dictionary: Dictionary<T, U>,
): Dictionary<T, U>[T];
export function translate<T extends string, U extends string>(
  terms: T[],
  dictionary: Dictionary<T, U>,
): Dictionary<T, U>[T][];
export function translate<T extends string, U extends string>(termOrTerms: T | T[], dictionary: Dictionary<T, U>) {
  return Array.isArray(termOrTerms) ? termOrTerms.map((t) => dictionary[t]) : dictionary[termOrTerms];
}

export default Dictionary;
